export const ENVIRONMENT_HERO_IMAGE =
    "/env-media/DJI_0131-e8a618e4-9e55-4e1e-8325-8796abce851e.png";

/** Home gallery — hand holding seedballs (add file to public/env-media/) */
export const SEEDBALLS_GALLERY_IMAGE = "/env-media/seedballs-hand.jpg";

export const ENVIRONMENT_SITES = [
    {
        id: "ngongongeri",
        name: "Ngongongeri Farm",
        region: "Njoro, Nakuru County",
        status: "active",
        lat: -0.315936334162948,
        lng: 35.907332029084415,
        summary:
            "Egerton University’s Ngongongeri Farm — our active restoration site.",
        description:
            "Hands-on planting with seedballs, seedlings, and community volunteers. Field days here pair dryland restoration with AI upskilling for local builders.",
        mapsUrl:
            "https://www.google.com/maps/search/?api=1&query=-0.315936334162948,35.907332029084415",
    },
    {
        id: "mogotio-quarry",
        name: "Mogotio Summer Rose Quarry",
        region: "Mogotio, Baringo County",
        status: "partnered",
        lat: -0.0482,
        lng: 35.9654,
        summary:
            "Former quarry on degraded land — partnered restoration with Summerrose.",
        description:
            "This is degraded land that once operated as a quarry. Build Bout has partnered with Summerrose to restore native cover here — seedballs, planting days, and long-term stewardship to bring the site back to life.",
        mapsUrl:
            "https://www.google.com/maps/search/?api=1&query=Mogotio+Summer+Rose+Quarry+Kenya",
    },
];

const MAP_PADDING = 0.06;

function computeMapBounds(sites) {
    const lats = sites.map((s) => s.lat);
    const lngs = sites.map((s) => s.lng);
    return {
        west: Math.min(...lngs) - MAP_PADDING,
        south: Math.min(...lats) - MAP_PADDING,
        east: Math.max(...lngs) + MAP_PADDING,
        north: Math.max(...lats) + MAP_PADDING,
    };
}

export const ENVIRONMENT_MAP_BOUNDS = computeMapBounds(ENVIRONMENT_SITES);

export const ENVIRONMENT = {
    title: "Sustainable Environment",
    tagline:
        "Reforest degraded drylands while upskilling our community with AI skills.",
    intro:
        "We support AI by restoring degraded lands — planting seedballs and trees in collaboration with universities, partners, and local organisations. Field work and upskilling go together.",
    videoIntro:
        "Watch how our community shows up on site — planting, learning, and building momentum for dryland restoration.",
    pillars: [
        {
            title: "Restore drylands",
            detail: "Seedballs, seedlings, and trees on real degraded sites — hands-on work with partners who share the same restoration goals.",
        },
        {
            title: "Upskill with AI",
            detail: "Field days pair with AI workshops — agents, automation, and practical skills builders can use in their work.",
        },
        {
            title: "Proof on the ground",
            detail: "We measure impact in hectares touched, trees planted, and people trained — not slides.",
        },
    ],
};

export const ENVIRONMENT_VIDEOS = [
    {
        id: "d__20Wa1VYA",
        url: "https://youtu.be/d__20Wa1VYA",
        title: "Restoration in the field",
    },
    {
        id: "LPa2Bu4M5OU",
        url: "https://youtu.be/LPa2Bu4M5OU",
        title: "Community planting day",
    },
];

export const ENVIRONMENT_PROOF = [
    {
        src: "/env-media/DJI_0122-a025c671-b3c3-4a73-8e11-9efbe5849eff.png",
        caption: "Dryland site — open field ready for restoration",
    },
    {
        src: "/env-media/DJI_0131-e8a618e4-9e55-4e1e-8325-8796abce851e.png",
        caption: "Community members preparing planting holes",
    },
    {
        src: "/env-media/DJI_0133-d3a52314-f383-42a3-8974-b2b10e68776d.png",
        caption: "Group work across the hillside",
    },
    {
        src: "/env-media/DJI_0137-72e8a8e2-10ca-4b6f-b932-c7017b6c5295.png",
        caption: "Coordinated planting day on degraded land",
    },
    {
        src: "/env-media/DJI_0162-41378a23-1100-48c2-87af-f1d812e6d265.png",
        caption: "Wide view — community spread across the site",
    },
    {
        src: "/env-media/DJI_0161-814abfde-801c-4489-9678-4a451bdc5ea5.png",
        caption: "Egerton University partnership — saplings and volunteers",
    },
];
